import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FjalaPerzgjedhurLeksikografiService } from '@core/services/fjala-perzgjedhur-leksikografi.service';
import { FjalaPerzgjedhurStrukturaService } from '@core/services/fjala-perzgjedhur-struktura.service';
import { NjoftimiService } from '@core/services/njoftimi-service.service';
import { OperatoriFaqjaService } from '@core/services/operatori-faqja.service';
import { OperatoriService } from '@core/services/operatori.service';
import { ParacaktimiKerkimitService } from '@core/services/paracaktimi-kerkimit.service';
import { QueryBuilderService } from '@core/services/query-builder.service';
import { MorfologjiaHubService } from '@core/services/signalr/morfologjia-hub.service';
import { catchError, filter, forkJoin, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { BurimiService } from '../services/burimi.service';
import { FjalaPerzgjedhurService } from '../services/fjala-perzgjedhur.service';
import { FrazatService } from '../services/frazat.service';

@Injectable({
  providedIn: 'root',
})
export class AppGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private morfologjiaHubService: MorfologjiaHubService,
    private operatoriFaqjaService: OperatoriFaqjaService,
    private frazatService: FrazatService,
    private fjalaPerzgjedhurService: FjalaPerzgjedhurService,
    private fjalaPerzgjedhurStrukturaService: FjalaPerzgjedhurStrukturaService,
    private fjalaPerzgjedhurLeksikografiService: FjalaPerzgjedhurLeksikografiService,
    private paracaktimiKerkimitService: ParacaktimiKerkimitService,
    private burimiService: BurimiService,
    private operatoriService: OperatoriService,
    private njoftimiService: NjoftimiService,
    private queryBuilderService: QueryBuilderService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkLogin(state.url);
  }

  private checkLogin(url?: string) {
    return this.authService.isDoneLoading$.pipe(
      filter((isDone) => isDone),
      switchMap((_) => this.authService.isAuthenticated$),
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          if (this.authService.hasLinguistPermission()) {
            return this.dataInitializor();
          } else {
            this.router.navigateByUrl('/unauthorized');
          }
        } else {
          this.authService.login(url);
        }
        return of(false);
      })
    );
  }

  private dataInitializor() {
    return forkJoin([
      this.morfologjiaHubService.initializeSignalR(),
      this.frazatService.load(),
      this.operatoriFaqjaService.load(),
      this.fjalaPerzgjedhurService.load(),
      this.fjalaPerzgjedhurStrukturaService.load(),
      this.fjalaPerzgjedhurLeksikografiService.load(),
      this.burimiService.load(),
      this.paracaktimiKerkimitService.load(),
      this.burimiService.load(),
      this.operatoriService.load(),
      this.njoftimiService.load()
    ]).pipe(
      switchMap(() => this.queryBuilderService.load()),
      tap(() => {}),
      map(() => true),
      catchError((err) => {
        if (err?.status == 403) {
          this.router.navigateByUrl('/forbidden');
        }
        return throwError(err);
      })
    );
  }
}
